"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fontWeightMedium = exports.fontWeightBook = exports.fontTextDecorationNone = exports.fontTextCaseNone = exports.fontSize46 = exports.fontSize36 = exports.fontSize26 = exports.fontSize24 = exports.fontSize18 = exports.fontSize16 = exports.fontSize14 = exports.fontSize13 = exports.fontSize12 = exports.fontParagraphSpacing0 = exports.fontLineHeight170 = exports.fontLineHeight150 = exports.fontLineHeight140 = exports.fontLineHeight130 = exports.fontLineHeight125 = exports.fontLineHeight120 = exports.fontLineHeight100 = exports.fontLetterSpacingMinus4 = exports.fontLetterSpacingMinus3 = exports.fontLetterSpacingMinus2 = exports.fontLetterSpacingMinus1 = exports.fontLetterSpacing4 = exports.fontLetterSpacing2 = exports.fontLetterSpacing1 = exports.fontLetterSpacing0 = exports.fontFamilyCentra = void 0;
const fontFamilyCentra = exports.fontFamilyCentra = '"Centra No 2"';
const fontWeightBook = exports.fontWeightBook = '400';
const fontWeightMedium = exports.fontWeightMedium = '500';
const fontSize12 = exports.fontSize12 = '12px';
const fontSize13 = exports.fontSize13 = '13px';
const fontSize14 = exports.fontSize14 = '14px';
const fontSize16 = exports.fontSize16 = '16px';
const fontSize18 = exports.fontSize18 = '18px';
const fontSize24 = exports.fontSize24 = '24px';
const fontSize26 = exports.fontSize26 = '26px';
const fontSize36 = exports.fontSize36 = '36px';
const fontSize46 = exports.fontSize46 = '46px';
const fontLetterSpacing0 = exports.fontLetterSpacing0 = '0em';
const fontLetterSpacing1 = exports.fontLetterSpacing1 = '0.01em';
const fontLetterSpacing2 = exports.fontLetterSpacing2 = '0.02em';
const fontLetterSpacing4 = exports.fontLetterSpacing4 = '0.04em';
const fontLetterSpacingMinus1 = exports.fontLetterSpacingMinus1 = '-0.01em';
const fontLetterSpacingMinus2 = exports.fontLetterSpacingMinus2 = '-0.02em';
const fontLetterSpacingMinus3 = exports.fontLetterSpacingMinus3 = '-0.03em';
const fontLetterSpacingMinus4 = exports.fontLetterSpacingMinus4 = '-0.04em';
const fontLineHeight100 = exports.fontLineHeight100 = '100%';
const fontLineHeight120 = exports.fontLineHeight120 = '120%';
const fontLineHeight125 = exports.fontLineHeight125 = '125%';
const fontLineHeight130 = exports.fontLineHeight130 = '130%';
const fontLineHeight140 = exports.fontLineHeight140 = '140%';
const fontLineHeight150 = exports.fontLineHeight150 = '150%';
const fontLineHeight170 = exports.fontLineHeight170 = '170%';
const fontParagraphSpacing0 = exports.fontParagraphSpacing0 = '0';
const fontTextCaseNone = exports.fontTextCaseNone = 'none';
const fontTextDecorationNone = exports.fontTextDecorationNone = 'none';